import { Checkbox } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ModalRemoveFromFavoritesContent.css';

interface IModalRemoveFromFavoritesContent {
  checked: boolean;
  onChange(checked: boolean): void;
}

export function ModalRemoveFromFavoritesContent({ checked, onChange }: IModalRemoveFromFavoritesContent) {
  return (
    <>
      <p className={styles['text']}>Объявления также будут удалены из всех подборок</p>
      <Checkbox label="Больше не показывать" checked={checked} onChange={e => onChange(e.target.checked)} />
    </>
  );
}
